import { useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { PurchaseOrderService } from "src/services";
import { PurchaseOrder, POInvoiceStatus } from "src/types";
import { queryKeys } from "src/constants";

export const useUpdatePurchaseOrderInvoiceStatus = (purchaseOrderService: PurchaseOrderService) => {
  const queryClient = useQueryClient();
  const [lastVariables, setLastVariables] = useState<{
    purchaseOrderId: string;
    invoiceStatus: POInvoiceStatus;
  } | null>(null);

  const updatePurchaseOrderInCache = (updatedPurchaseOrder: PurchaseOrder) => {
    queryClient.setQueryData(queryKeys.purchaseOrder(updatedPurchaseOrder.id), () => updatedPurchaseOrder);
  };

  const {
    mutate: updateInvoiceStatus,
    isPending: isUpdatingInvoiceStatus,
    error: invoiceStatusUpdateError,
    reset: resetInvoiceStatusUpdate
  } = useMutation<PurchaseOrder, Error, { purchaseOrderId: string; invoiceStatus: POInvoiceStatus }>({
    mutationFn: ({ purchaseOrderId, invoiceStatus }) =>
      purchaseOrderService.updatePurchaseOrderInvoiceStatus(purchaseOrderId, invoiceStatus),
    onSuccess: updatePurchaseOrderInCache,
    onMutate: (variables) => {
      setLastVariables(variables);
    }
  });

  const retryInvoiceStatusUpdate = () => {
    if (lastVariables) {
      updateInvoiceStatus(lastVariables);
    }
  };

  return {
    updateInvoiceStatus,
    isUpdatingInvoiceStatus,
    invoiceStatusUpdateError,
    retryInvoiceStatusUpdate,
    resetInvoiceStatusUpdate
  };
};
